import { render, staticRenderFns } from "./babybook-preview.vue?vue&type=template&id=13282ebe"
import script from "./babybook-preview.vue?vue&type=script&lang=js"
export * from "./babybook-preview.vue?vue&type=script&lang=js"
import style0 from "./babybook-preview.vue?vue&type=style&index=0&id=13282ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports